/** Daywia legal / operator details — used across public policy pages. */

export const LEGAL_LAST_UPDATED = "9 June 2026";

export const PUBLIC_SITE = "https://www.daywia.com" as const;

/** Payment gateway named on public policies (Cashfree merchant onboarding). */
export const PAYMENTS = {
  provider: "Cashfree Payments",
  providerShort: "Cashfree",
  /** RBI-mandated policy URLs — paste these into Cashfree onboarding. */
  policyUrls: {
    contactUs: `${PUBLIC_SITE}/ContactUs`,
    terms: `${PUBLIC_SITE}/TermsandConditions`,
    refundCancellation: `${PUBLIC_SITE}/RefundandCancellation`,
  },
} as const;

export const OPERATOR = {
  name: "Kodavatikanti Niranjan",
  age: 30,
  product: "Daywia",
  address: {
    line: "1/101, Papireddypalle (Village)",
    post: "Kondavaripalle (Post)",
    mandal: "Bramhamgarimattam (Mandal)",
    district: "Kadapa (District)",
    state: "Andhra Pradesh",
    country: "India",
    pincode: "516503",
  },
} as const;

export const CONTACT = {
  admin: "admin@daywia.com",
  support: "support@daywia.com",
  help: "help@daywia.com",
  noreply: "no-reply@daywia.com",
  phones: ["+91 91107 53692", "+91 82971 96198"] as const,
} as const;

export function formatAddress(): string {
  const a = OPERATOR.address;
  return `${a.line}, ${a.post}, ${a.mandal}, ${a.district}, ${a.state}, ${a.country} — ${a.pincode}`;
}

export const LEGAL_LINKS = [
  { to: "/legal", label: "Legal" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/guidelines", label: "Guidelines" },
  { to: "/contact", label: "Contact" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About" },
  { to: "/download", label: "Download" },
] as const;
